import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dialog } from '@zebra-fed/zds-react-desktop';
import { useTranslation } from "react-i18next";
import { useFormik } from 'formik';
import TextField from "@material-ui/core/TextField";
import { makeStyles } from '@material-ui/core/styles';
import DropdownWithBorders from '../../components/DropdownWithBorders';
import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import * as firebase from "firebase/app";

const PopupContainer = styled.div`
    font-family: 'Roboto';
`
const PopupHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 21px;
    font-weight: 600;
    padding: 10px 0 0 20px;
`
const HeadDes = styled.div`
    padding: 0 0 0 20px;
`
const FooterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px 10px 0;

    button{
        outline: 0;
        // border: 0;
        padding: 8px 12px;
        font-size: 14px;
        cursor: pointer;
        font-family: 'Roboto';
        transition: all 0.2s;
    }

    button + button{
        margin-left: 12px;
    }
`

const BlueBtn = styled.button`
    color: #fff;
    background: #007ABA;
    border: 2px solid #007ABA;

    &:hover{
        background: #025681;
        border-color: #025681;
    }
`
const TransBtn = styled.button`
    color: #3b3d46;
    background: #fff;
    border: 2px solid #3b3d46;
    font-weight: 500;

    &:hover{
        background: #e0dddd;
        border-color: #e0dddd;
    }
`
const BodyContent = styled.div`
    display: flex;
    justify-content: center;
    padding: 15px 20px 40px 20px;
    height: calc(100vh - 340px);
    overflow-y: auto;
    form{
        width: 100%;
    }
`
const Formcontainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 10px;
`

const StyledTextField = styled(TextField)`
  display: flex;
  width: 100%;

  input{
  padding: 9px !important;

      &:focus{
        border-color:#2684FF !important;
    }
  }

  & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: #2684FF !important;
      }
    }

`;

const LabelText = styled.label`
    color: #4f4f4f;
    font-size: 15px;
`

const ErrorLine = styled.p`
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    margin-left: 14px;
    color: #f44336;
`

// color: #f44336;
// margin: 0;
// font-size: 0.75rem;
// margin-top: 3px;
// text-align: left;
// font-family: "Roboto", "Helvetica", "Arial", sans-serif;
// font-weight: 400;
// line-height: 1.66;
// letter-spacing: 0.03333em;
// margin-left: 15px;

const useStyles = makeStyles((theme) => ({
    dropdown: {
        minWidth: '420px'
    },
}));

export default function AddDevicesPopUp(props) {
    const classs = useStyles();
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const context = useContext(AuthContext);
    const companyID = context.currentUser.claims.companyID;
    const firestore = app.firestore();


    const [siteData, setsiteData] = useState([])
    const [defaultSiteData, setdefaultSiteData] = useState([])
    const [siteIsLoading, setIsLoading] = useState(false)
    const [IsAdding, setIsAdding] = useState(false)
    const [ConfirmClicked, setConfirmClicked] = useState(false)
    const [DeviceDuplicate, setDeviceDuplicate] = useState(false)

    const validates = (t) => {
        return async (val) => {
            const errors = {};
            const specialChar = /[^A-Za-z0-9_@#$%&*!+.^()=\-\[\]?><:]/g

            if (!val.ModelNumber.trim()) { errors.ModelNumber = t('validation.rules.Mo_Dash.EmptyModelNumber') }
            else if (val.ModelNumber.length > 32) { errors.ModelNumber = t('validation.rules.Mo_Dash.MoNo32Len') }

            if (!val.SerialNumber.trim()) { errors.SerialNumber = t('validation.rules.Mo_Dash.EmptySerialNumber') }
            else if (val.SerialNumber.length > 32) { errors.SerialNumber = t('validation.rules.Mo_Dash.SeNo32Len') }

            if (val.DeviceFriendlyName.trim()) {
                if (specialChar.test(val.DeviceFriendlyName)) {
                    errors.DeviceFriendlyName = t('validation.rules.Mo_Dash.SpecialCharDevN')
                } else if (val.DeviceFriendlyName.length > 32) {
                    errors.DeviceFriendlyName = t('validation.rules.Mo_Dash.DeFrNa32Len')
                }
            }
            // if (!val.SiteName) { errors.SiteName = t('validation.rules.Mo_Dash.SiteNotSelected') }
            return errors;
        }
    }


    const validate = validates(t);

    const Form = useFormik({
        enableReinitialize: true,
        initialValues: {
            ModelNumber: '',
            SerialNumber: '',
            DeviceFriendlyName: '',
            SiteName: '',
        },
        validate,
        onSubmit: async (values) => {

            try {
                setIsAdding(true);

                // let data = (await firestore.collection("tenants")
                //     .doc(companyID)
                //     .collection('Devices')
                //     .where('friendlyName', '==', values.DeviceFriendlyName.toUpperCase())
                //     .get()).docs.map((doc) => doc.data());

                // if (data == undefined || data == null || data.length == 0) { setDeviceDuplicate(false); }
                // else { setDeviceDuplicate(true); setIsAdding(false); return }

                const updateData = {
                    modelNumber: values.ModelNumber.toUpperCase(),
                    displayModelNumber: values.ModelNumber,
                    serialNumber: values.SerialNumber.toUpperCase(),
                    displaySerialNumber: values.SerialNumber,
                    friendlyName: values.DeviceFriendlyName.toUpperCase(),
                    displayDeviceFriendlyName: values.DeviceFriendlyName,
                    siteName: values.SiteName?.value ? values.SiteName?.value : "",
                    displaySiteName: values.SiteName?.displayName ? values.SiteName?.displayName : "",
                    lastUpdatedAt: Date.now(),
                    reportedAt: Date.now()
                };

                const docId = `${updateData.modelNumber}_${updateData.serialNumber}`;


                props.popUpTrigger({
                    from: 'add',
                    msg: { show: false }
                });

                const docRef = firestore.collection("tenants")
                    .doc(companyID)
                    .collection('Devices')
                    .doc(docId);

                let batch = firestore.batch();

                // batch.update(docRef, updateData)
                batch.set(docRef, updateData, { merge: true })


                const Moniter_docRef = firestore.collection("tenants")
                    .doc(companyID)
                    .collection('Devices')
                    .doc(updateData.modelNumber + '_' + updateData.serialNumber)
                    .collection("Monitor")
                    .doc('Assignment');

                batch.set(Moniter_docRef, {
                    displaySerialNumber: values.SerialNumber,
                    friendlyName: values.DeviceFriendlyName.toUpperCase(),
                    displayDeviceFriendlyName: values.DeviceFriendlyName,
                    siteName: values.SiteName?.value ? values.SiteName.value: "",
                    displaySiteName: values.SiteName.displayName ? values.SiteName?.displayName: "",
                }, { merge: true })

                await batch.commit();

                props.popUpTrigger({
                    from: 'add',
                    msg: { show: true, error: false, data: t("Mo_Dash.placeholders.DevicesAddedSuccessfully")  }
                })

                setTimeout(() => { setIsAdding(false); onClose(true) }, 1000);

            } catch (e) {
                console.log(e)
                setIsAdding(false);
                props.popUpTrigger({
                    from: 'add',
                    msg: { show: true, error: true,data: t("Mo_Dash.placeholders.DevicesAddedFailed") }
                })
            }
        },
    });

    const getSelectInputSearch = async (rawInput, type) => {
        try {

            let Query = firestore
                .collection('tenants')
                .doc(companyID)
                .collection('SiteLocations')
                .orderBy('siteName');

            let proceed = false;

            if (type == 'ENTERHIT') {
                Query = Query.startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
                proceed = true;
            } else if (type == 'INIT') { proceed = true; }

            if (proceed) {
                let sites = [];
                setIsLoading(true);
                sites = (await Query.limit(10).get()).docs.map((doc) => doc.data());
                let finalSitesArray = [{ label: "Select Site", value: "", displayName: "" }];
                if (sites.length > 0) {
                    sites.forEach(ele => {
                        finalSitesArray.push({ label: ele.siteName, value: ele.siteName, displayName: ele.displaySiteName })
                    });
                }
                setsiteData(finalSitesArray)
                if(type == 'INIT'){setdefaultSiteData(finalSitesArray)}
                setIsLoading(false);
            }
        } catch (err) { console.log(err, 'wewe') }
    }

    useEffect(() => { getSelectInputSearch('', 'INIT') }, [])

    const onConfirmClicked = () => {
        setConfirmClicked(true);
        Form.handleSubmit();
    }

    const onClose = (e = false) => {
        Form.resetForm();
        setsiteData(defaultSiteData)
        props.popUpTrigger({ from: 'add', close: true, needToLoad: e })
    }

    return (
        <Dialog
            ref={dialogRef}
            key='dialog2'
            width='520px'
            headerStyle={{ display: 'none' }}
            bodyStyle={{ padding: '0px', width: '100%' }}
            cardStyle={{ minWidth: '100px !important', padding: '10px' }}
            footerStyle={{ display: 'none' }}>

            <PopupContainer>
                <PopupHeader>{t('Mo_Dash.placeholders.add')}</PopupHeader>
                <HeadDes>{t('manual')}</HeadDes>

                <BodyContent>
                    <form noValidate onSubmit={Form.handleSubmit}
                        style={{ pointerEvents: IsAdding ? 'none' : '' }}
                    >

                        <Formcontainer>
                            <LabelText>{t('Mo_Dash.placeholders.sitename')}</LabelText>
                            <DropdownWithBorders
                                selectOpts={siteData}
                                onChange={(e) => { Form.setFieldValue('SiteName', e) }}
                                resetSelect={false}
                                selectVal={Form.values.SiteName}
                                isSearchable={true}
                                onSearchInpChange={getSelectInputSearch}
                                customFilterOption={() => { return siteData }}
                                selectOnBlur={() => { }}
                                error={Form.errors.SiteName && ConfirmClicked}
                                isLoading={siteIsLoading}
                            />
                            <ErrorLine style={{ display: Form.errors.SiteName && ConfirmClicked ? 'block' : 'none' }}>
                                {t('validation.rules.Mo_Dash.SiteNotSelected')}
                            </ErrorLine>
                        </Formcontainer>

                        <Formcontainer>
                            <LabelText>{t('Mo_Dash.placeholders.modelNo')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={Form.errors.ModelNumber && Form.touched.ModelNumber ? true : false}
                                onChange={Form.handleChange('ModelNumber')}
                                onBlur={Form.handleBlur('ModelNumber')}
                                value={Form.values.ModelNumber}
                                helperText={
                                    Form.errors.ModelNumber && Form.touched.ModelNumber ?
                                        Form.errors.ModelNumber : null
                                }
                                placeholder={t('Mo_Dash.placeholders.enter_mo_no')}
                            />
                        </Formcontainer>

                        <Formcontainer>
                            <LabelText>{t('Mo_Dash.placeholders.serialNo')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={Form.errors.SerialNumber && Form.touched.SerialNumber ? true : false}
                                onChange={Form.handleChange('SerialNumber')}
                                onBlur={Form.handleBlur('SerialNumber')}
                                value={Form.values.SerialNumber}
                                helperText={
                                    Form.errors.SerialNumber && Form.touched.SerialNumber ?
                                        Form.errors.SerialNumber : null
                                }
                                placeholder={t('Mo_Dash.placeholders.enter_Se_no')}
                            />
                        </Formcontainer>

                        <Formcontainer>
                            <LabelText>{t('Mo_Dash.placeholders.devicename')}</LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={(Form.errors.DeviceFriendlyName && Form.touched.DeviceFriendlyName ? true : false)}
                                onChange={Form.handleChange('DeviceFriendlyName')}
                                onBlur={Form.handleBlur('DeviceFriendlyName')}
                                value={Form.values.DeviceFriendlyName}
                                helperText={
                                    Form.errors.DeviceFriendlyName && Form.touched.DeviceFriendlyName ?
                                        Form.errors.DeviceFriendlyName : null
                                }
                                placeholder={t('Mo_Dash.placeholders.EnterDevicename')}
                            />
                            {/* <p>{t('Mo_Dash.placeholders.DuplicateDevicename')}</p> */}
                            {/* <ErrorLine style={{ display: (!Form.errors.DeviceFriendlyName && DeviceDuplicate) ? 'block' : 'none' }}>
                                {t('Mo_Dash.placeholders.DuplicateDevicename')}
                            </ErrorLine> */}
                        </Formcontainer>

                    </form>

                </BodyContent>

                <FooterContainer style={{ pointerEvents: IsAdding ? 'none' : '' }}>
                    <TransBtn onClick={() => { onClose(false) }}>{t('cancel')}</TransBtn>
                    <BlueBtn onClick={onConfirmClicked}>{IsAdding ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                </FooterContainer>

            </PopupContainer>

        </Dialog>
    )
}





